module.exports = __webpack_public_path__ + "img/state1.d59b72a2.webp";